import React, { useEffect, useState, useCallback } from "react"
import { API } from "../../api"
import Total from "./Total"
import "./Amounts.css"

export default function Amounts({
  orderData,
  discountAmount,
  subTotal,
  shippingRate,
  deliveryMethodName,
  isTaxInclusive,
  taxDetails
}) {
  const deliveryMethod = deliveryMethodName

  const currency = (orderData && orderData.currency) || ""

  const [computations, setComputations] = useState({
    computedSubtotal: 0,
    discount: 0,
    salesBeforeTax: 0,
    tax: 0,
    total: 0
  })

  async function computeOrder() {
    try {
      const computeDetails = {
        subtotal: parseFloat(subTotal),
        discount_amount: parseFloat(discountAmount),
        shipping_fee: shippingRate || 0,
        tax_percentage: parseFloat((taxDetails && taxDetails.percentage) || 0),
        is_percentage: orderData.is_percentage,
        is_sc_taxable: orderData.is_sc_taxable,
        is_tax_inclusive: isTaxInclusive,
        is_custom_tax: orderData.is_custom_tax
      }
      const computedData = await API.post(
        `/orders/computation`,
        JSON.stringify(computeDetails)
      )
      if (computedData && computedData.data) {
        const data = computedData.data
        const newComputedData = {
          computedSubtotal: isTaxInclusive ? data.sales_before_tax : data.total,
          discount: data.discount,
          salesBeforeTax: data.sales_before_tax,
          tax: data.tax,
          total: data.total
        }
        setComputations(newComputedData)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const memoizedComputeOrder = useCallback(computeOrder, [
    subTotal,
    discountAmount,
    shippingRate,
    orderData.is_percentage,
    orderData.is_sc_taxable,
    isTaxInclusive,
    orderData.is_custom_tax,
    taxDetails
  ])

  useEffect(
    () => {
      memoizedComputeOrder()
    },
    [memoizedComputeOrder]
  )
  return (
    <>
      <div className="Amounts hide-on-mobile">
        <div className="amount-item">
          <span className="bold">
            {orderData && isTaxInclusive ? "Sales before tax" : "Subtotal"}
          </span>
          <span>
            <span>
              {parseFloat(computations.salesBeforeTax).toLocaleString("en", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })}
            </span>
            <span> {currency}</span>
          </span>
        </div>
        {(orderData &&
          orderData.discount_amount &&
          orderData.discount_amount > 0 && (
            <div className="amount-item">
              <span className="bold">
                {(orderData.discount_reason &&
                  orderData.discount_reason !== "" &&
                  orderData.discount_reason) ||
                  "Discount"}
                {orderData.is_percentage
                  ? ` (${orderData.discount_amount}%)`
                  : ""}
              </span>
              <span>
                <span>
                  -{" "}
                  {parseFloat(computations.discount).toLocaleString("en", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                  })}
                </span>
                <span> {currency}</span>
              </span>
            </div>
          )) ||
          null}
        {deliveryMethod && (
          <div className="amount-item">
            <span className="bold">{deliveryMethod}</span>
            <span>
              <span>
                {orderData.rate_type === "courier" &&
                deliveryMethod.toLowerCase() === "lalamove" &&
                shippingRate === 0
                  ? "-"
                  : `${parseFloat(shippingRate).toLocaleString("en", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    })} ${currency}`}
              </span>
            </span>
          </div>
        )}
        {taxDetails &&
          parseFloat(taxDetails.percentage) > 0 && (
            <div className="amount-item">
              <span className="bold">{`${taxDetails.name} (${
                taxDetails.percentage
              }%)`}</span>
              <span>
                {parseFloat(computations.tax).toLocaleString("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}{" "}
                {currency}
              </span>
            </div>
          )}
      </div>
      <Total
        grandTotal={computations && computations.total}
        currency={orderData.currency}
        paymentDetail={orderData.payment_detail}
        paymentStatus={orderData.payment_status}
        refundAmount={orderData.refund_amount}
      />
    </>
  )
}
